import React from 'react';
import styles from '../css/reports.module.css';
import { useState } from 'react';
import { TbReportAnalytics } from 'react-icons/tb';
import { FaHome } from 'react-icons/fa';
import {
  //Slide,
  toast,
  ToastContainer,
  //ToastContainer,
} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from 'react-router-dom';

function ReportsHero({
  activityRpt,
  stayRpt,
  waitTimeRpt,
  activityByHoursRpt,
  data,
  inTrafficData,
  openTicketsData,
  closedTicketsData,
  outTrafficData,
  startDate,
  endDate,
  setStartDate,
  setEndDate,
  runReport,
  reportsOptions,
}) {
  const [isActivityReportChecked, setIsActivityReportChecked] = useState(false);
  const [isStayReportChecked, setIsStayReportChecked] = useState(false);
  const [isWaitTimeReportChecked, setIsWaitTimeReportChecked] = useState(false);
  const [isActivityByHoursChecked, setIsActivityByHoursChecked] = useState(false);
  const [isOpenTicketsReportChecked, setIsOpenTicketsReportChecked] = useState(false);
  const [isClosedTicketsReportChecked, setIsClosedTicketsReportChecked] = useState(false);
  const [isTicketsIssuedReportChecked, setIsTicketsIssuedReportChecked] = useState(false);
  const [isOutTrafficReportChecked, setIsOutTrafficReportChecked] = useState(false);
  const navigate = useNavigate();

  return (
    <div className={styles.heroWrapper}>
      <ToastContainer
        autoClose={8000}
        pauseOnHover={true}
        rtl={false}
        pauseOnFocusLoss={false}
        newestOnTop={true}
        theme="light"
        position="top-center"
      />
      <div className={styles.homeBtnDiv}>
        <button
          onClick={() => {
            navigate('/');
          }}
        >
          <FaHome /> Home
        </button>
      </div>
      <div className={styles.checkboxContainer}>
        <label htmlFor="checkbox" className={styles.heroLabel}>
          <input
            type="checkbox"
            className={styles.checkbox}
            id="checkbox"
            checked={isActivityReportChecked}
            onChange={() => {
              setIsStayReportChecked(false);
              setIsWaitTimeReportChecked(false);
              setIsActivityByHoursChecked(false);
              setIsOpenTicketsReportChecked(false);
              setIsClosedTicketsReportChecked(false);
              setIsTicketsIssuedReportChecked(false);
              setIsOutTrafficReportChecked(false);
              setIsClosedTicketsReportChecked(false);
              setIsActivityReportChecked(!isActivityReportChecked);
              activityRpt();
              data();
            }}
          />
          <span> Activity Report</span>
        </label>
        <label htmlFor="checkbox2" className={styles.heroLabel}>
          <input
            type="checkbox"
            className={styles.checkbox}
            id="checkbox2"
            checked={isActivityByHoursChecked}
            onChange={() => {
              setIsActivityReportChecked(false);
              setIsWaitTimeReportChecked(false);
              setIsStayReportChecked(false);
              setIsOpenTicketsReportChecked(false);
              setIsClosedTicketsReportChecked(false);
              setIsTicketsIssuedReportChecked(false);
              setIsOutTrafficReportChecked(false);
              setIsClosedTicketsReportChecked(false);
              setIsActivityByHoursChecked(!isActivityByHoursChecked);
              activityByHoursRpt();
              data();
            }}
          />
          <span> Activity by Hours</span>
        </label>
        <label htmlFor="checkbox3" className={styles.heroLabel}>
          <input
            type="checkbox"
            className={styles.checkbox}
            id="checkbox3"
            checked={isStayReportChecked}
            onChange={() => {
              setIsActivityReportChecked(false);
              setIsWaitTimeReportChecked(false);
              setIsActivityByHoursChecked(false);
              setIsOutTrafficReportChecked(false);
              setIsTicketsIssuedReportChecked(false);
              setIsOutTrafficReportChecked(false);
              setIsClosedTicketsReportChecked(false);
              setIsStayReportChecked(!isStayReportChecked);
              stayRpt();
            }}
          />
          <span> Stay Duration Report</span>
        </label>
        <label htmlFor="checkbox4" className={styles.heroLabel}>
          <input
            type="checkbox"
            className={styles.checkbox}
            id="checkbox4"
            checked={isWaitTimeReportChecked}
            disabled={true}
            onChange={() => {
              setIsActivityReportChecked(false);
              setIsStayReportChecked(false);
              setIsActivityByHoursChecked(false);
              setIsClosedTicketsReportChecked(false);
              setIsOpenTicketsReportChecked(false);
              setIsTicketsIssuedReportChecked(false);
              setIsOutTrafficReportChecked(false);
              setIsWaitTimeReportChecked(!isWaitTimeReportChecked);
              waitTimeRpt();
            }}
          />
          <span> Wait Time Report</span>
        </label>
        <label htmlFor="checkbox5" className={styles.heroLabel}>
          <input
            type="checkbox"
            className={styles.checkbox}
            id="checkbox5"
            checked={isOpenTicketsReportChecked}
            onChange={() => {
              setIsActivityReportChecked(false);
              setIsStayReportChecked(false);
              setIsActivityByHoursChecked(false);
              setIsClosedTicketsReportChecked(false);
              setIsOpenTicketsReportChecked(false);
              setIsTicketsIssuedReportChecked(false);
              setIsWaitTimeReportChecked(false);
              setIsClosedTicketsReportChecked(false);
              setIsOutTrafficReportChecked(false);
              setIsOpenTicketsReportChecked(!isOpenTicketsReportChecked);
              openTicketsData();
            }}
          />
          <span>Open Tickets Report</span>
        </label>
        <label htmlFor="checkbox6" className={styles.heroLabel}>
          <input
            type="checkbox"
            className={styles.checkbox}
            id="checkbox6"
            name="checkbox6"
            checked={isClosedTicketsReportChecked}
            onChange={() => {
              setIsActivityReportChecked(false);
              setIsStayReportChecked(false);
              setIsActivityByHoursChecked(false);
              setIsClosedTicketsReportChecked(false);
              setIsOpenTicketsReportChecked(false);
              setIsTicketsIssuedReportChecked(false);
              setIsWaitTimeReportChecked(false);
              setIsOutTrafficReportChecked(false);
              setIsClosedTicketsReportChecked(!isClosedTicketsReportChecked);
              closedTicketsData();
            }}
          />
          <span>Closed Tickets Report</span>
        </label>
        <label htmlFor="checkbox6" className={styles.heroLabel}>
          <input
            type="checkbox"
            className={styles.checkbox}
            id="checkbox7"
            name="checkbox7"
            checked={isTicketsIssuedReportChecked}
            onChange={() => {
              setIsActivityReportChecked(false);
              setIsStayReportChecked(false);
              setIsActivityByHoursChecked(false);
              setIsClosedTicketsReportChecked(false);
              setIsOpenTicketsReportChecked(false);
              setIsTicketsIssuedReportChecked(false);
              setIsWaitTimeReportChecked(false);
              setIsClosedTicketsReportChecked(false);
              setIsOpenTicketsReportChecked(false);
              setIsOutTrafficReportChecked(false);
              setIsTicketsIssuedReportChecked(!isTicketsIssuedReportChecked);
              inTrafficData();
            }}
          />
          <span> In Traffic Report</span>
        </label>
        <label htmlFor="checkbox8" className={styles.heroLabel}>
          <input
            type="checkbox"
            className={styles.checkbox}
            id="checkbox8"
            name="checkbox8"
            checked={isOutTrafficReportChecked}
            onChange={() => {
              setIsActivityReportChecked(false);
              setIsStayReportChecked(false);
              setIsActivityByHoursChecked(false);
              setIsClosedTicketsReportChecked(false);
              setIsOpenTicketsReportChecked(false);
              setIsTicketsIssuedReportChecked(false);
              setIsWaitTimeReportChecked(false);
              setIsOutTrafficReportChecked(!isOutTrafficReportChecked);
              outTrafficData();
            }}
          />
          <span> Out Traffic Report</span>
        </label>
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'flex-start',
        }}
      >
        <div>
          <label className={styles.dateLabel}>Start Date:</label>
          <input
            type="date"
            className={styles.dateInput}
            value={startDate || ''}
            onChange={(e) => {
              setStartDate(e.target.value);
            }}
          />
          <label className={styles.dateLabel}>End Date:</label>
          <input
            type="date"
            className={styles.dateInput}
            value={endDate || ''}
            onChange={(e) => {
              setEndDate(e.target.value);
            }}
          />
          <button
            type="button"
            className={styles.reportButton}
            onClick={() => {
              if (reportsOptions === 0) {
                toast.error('Please select a report type checkbox before running reports.');
                return;
              }
              runReport();
            }}
          >
            <TbReportAnalytics
              style={{
                marginRight: '8px',
              }}
            />
            Fetch Report
          </button>
        </div>
      </div>
    </div>
  );
}

export default ReportsHero;
